import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

type HeaderProps = {
  title?: string;
};

export const Header = (props: HeaderProps) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <FontAwesomeIcon
        icon={faSparkles}
        fontSize="14"
        style={{
          color: unifiedPlatformColorPalette.lightBlue,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontWeight: 600,
          textTransform: 'uppercase',
          background: 'linear-gradient(90deg, #2278B3 0%, #FF4081 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        AI Insights
      </Typography>
      {!!props.title && (
        <Typography color={unifiedPlatformColorPalette.lightTextSecondary}>
          | {props.title}
        </Typography>
      )}
    </Box>
  );
};
